import Swal from 'sweetalert2';

export function loadingDialog() {
  Swal.fire({
    didOpen: () => {
      Swal.showLoading();
    },
    background: 'transparent',
    allowOutsideClick: false,

    showConfirmButton: false,
  });
}
export function deleteDialog() {
  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-success',
      cancelButton: 'btn btn-danger',
    },
    buttonsStyling: false,
  });
  return swalWithBootstrapButtons.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'No, cancel!',
    reverseButtons: true,
  });
}

export function successDialog(message: string) {
  return Swal.fire({
    icon: 'success',
    title: message,

    timer: 2500,
    showConfirmButton: false,
    timerProgressBar: true,

    willOpen: () => {
      const swalPopup = document.querySelector(
        '.swal2-container'
      ) as HTMLElement;
      if (swalPopup) {
        swalPopup.style.zIndex = '1000';
      }
    },
  });
}

export function saveChangeDialog() {
  return Swal.fire({
    title: 'Do you want to save the changes?',
    showDenyButton: true,
    showCancelButton: false,
    confirmButtonText: 'Save',
    denyButtonText: `Don't save`,
    customClass: {
      popup: 'update-alert',
    },
  });
}
export function errorDialog(message: string): void {
  Swal.fire({
    icon: 'error',
    title: 'Error',
    text: message || 'Something went wrong!',
  });
}
